import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.ogestyle.com';

function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // 'verifying', 'success', 'error'
  const [message, setMessage] = useState('Verifying your email...');
  
  const token = searchParams.get('token');
  const email = searchParams.get('email');
  const type = searchParams.get('type'); // 'freelancer' or undefined (owner)

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Invalid verification link. Token is missing.');
      return;
    }

    verifyEmail();
    // eslint-disable-next-line
  }, []);

  const verifyEmail = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/owners/verify?token=${token}`);
      
      if (response.data.status === 'success' || response.data.verified) {
        setStatus('success');
        setMessage('Email verified successfully! Redirecting to login...');
        
        // Redirect to login after 2 seconds
        setTimeout(() => {
          navigate(`/login?email=${encodeURIComponent(email)}`);
        }, 2000);
      } else {
        setStatus('error');
        setMessage('Verification failed. Please try again.');
      }
    } catch (error) {
      setStatus('error');
      const errorMsg = error.response?.data?.message || 'Verification failed. The link may be expired or invalid.';
      setMessage(errorMsg);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #1a659e 0%, #2980b9 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        background: 'white',
        padding: '40px',
        borderRadius: '16px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        maxWidth: '500px',
        width: '100%',
        textAlign: 'center'
      }}>
        {status === 'verifying' && (
          <>
            <div style={{
              width: '80px',
              height: '80px',
              border: '5px solid #f3f3f3',
              borderTop: '5px solid #1a659e',
              borderRadius: '50%',
              margin: '0 auto 24px',
              animation: 'spin 1s linear infinite'
            }} />
            <style>{`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}</style>
            <h2 style={{
              fontSize: '24px',
              fontWeight: 'bold',
              marginBottom: '16px',
              color: '#333'
            }}>
              Verifying Your Email
            </h2>
            <p style={{ fontSize: '16px', color: '#666' }}>
              Please wait while we verify your email address...
            </p>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={{
              width: '80px',
              height: '80px',
              background: '#4caf50',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 24px',
              fontSize: '40px',
              color: 'white'
            }}>
              ✓
            </div>
            <h2 style={{
              fontSize: '24px',
              fontWeight: 'bold',
              marginBottom: '16px',
              color: '#333'
            }}>
              Email Verified!
            </h2>
            <p style={{ fontSize: '16px', color: '#666', marginBottom: '24px' }}>
              {message}
            </p>
            <p style={{ fontSize: '14px', color: '#999' }}>
              Redirecting you to {type === 'freelancer' ? 'complete your profile' : 'continue registration'}...
            </p>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{
              width: '80px',
              height: '80px',
              background: '#ff4444',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 24px',
              fontSize: '40px',
              color: 'white'
            }}>
              ✗
            </div>
            <h2 style={{
              fontSize: '24px',
              fontWeight: 'bold',
              marginBottom: '16px',
              color: '#333'
            }}>
              Verification Failed
            </h2>
            <p style={{ fontSize: '16px', color: '#666', marginBottom: '24px' }}>
              {message}
            </p>
            <button
              onClick={() => navigate(type === 'freelancer' ? '/freelancer/signup' : '/register-shop')}
              style={{
                padding: '12px 32px',
                background: '#1a659e',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer'
              }}
            >
              Try Again
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default VerifyEmailPage;
